import { Component } from '@angular/core';
import { Controls } from '../../model/model';
import { NgForm } from '@angular/forms';
import { ValueService } from '../../shared/value.service';
import { Router } from '@angular/router';
import {
  maxAppId,
  minAppId,
  one,
  fortyfour,
  tagsLength,
  two,
  zero,
} from '../../shared/constant';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
    standalone: false
})
export class HomeComponent {
  isFormSubmitted = false;
  userForm!: NgForm;

  agentSan!: number;
  applicationID = '';
  producerId!: number;
  startDate = '';
  endDate = '';
  today: Date = new Date();
  maxDate: Date = new Date();

  tags: string[] = [];
  inputValue = '';
  sanInputValue = '';
  validationError = false;
  appIdError = false;
  maxDateError = false;
  futureDateError = false;

  constructor(
    private readonly sharedService: ValueService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.maxDate.setDate(this.maxDate.getDate() - fortyfour);
    this.today = new Date();
    //Today Date
    const enddate = document.getElementById('enddate') as HTMLInputElement;
    const today = new Date();
    const formatedToday = this.formatDate(today);

    //Last 45 days
    const startdate = document.getElementById('startdate') as HTMLInputElement;
    const fortyfivedaysago = new Date();
    fortyfivedaysago.setDate(fortyfivedaysago.getDate() - fortyfour);
    const fortyfivedaysagoFormatted = this.formatDate(fortyfivedaysago);

    startdate.min = fortyfivedaysagoFormatted;
    startdate.max = formatedToday;

    enddate.min = fortyfivedaysagoFormatted;
    enddate.max = formatedToday;

    this.getAgentsan();
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + one).padStart(two, '0');
    const day = String(date.getDate()).padStart(two, '0');
    return `${year}-${month}-${day}`;
  }

  addTag(event: KeyboardEvent) {
    const pattern = /^[A-Za-z0-9]*$/;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (
        pattern.test(this.inputValue) &&
        this.inputValue.length >= minAppId &&
        this.inputValue.length <= maxAppId
      ) {
        this.addTags(this.inputValue.trim());
        this.inputValue = '';
        this.appIdError = false;
      } else {
        this.appIdError = true;
      }
    }
  }

  addTags(tag: string) {
    if (this.tags.length < tagsLength && !this.tags.includes(tag)) {
      this.tags.push(tag);
    }
  }

  removeTag(tag: string) {
    this.tags = this.tags.filter((t) => t !== tag);
  }

  focusInput(): void {
    const inputElement = document.querySelector('input') as HTMLInputElement;
    inputElement.focus();
  }

  onStartDateChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const selectedStartDate = target.value;
    const enddate = document.getElementById('enddate') as HTMLInputElement;
    enddate.min = selectedStartDate;
  }

  onEndDateChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const selectedEndDate = target.value;
    const startdate = document.getElementById('startdate') as HTMLInputElement;
    startdate.max = selectedEndDate;
  }

  resetTime(date: Date) {
    const now = new Date();
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() + one,
      now.getHours() + one,
      now.getMinutes(),
      now.getSeconds()
    );
  }

  onClick(userForm: NgForm) {
    if (
      this.tags.length >= one &&
      !userForm.value.start &&
      !userForm.value.end
    ) {
      this.getEntity();
    } else if (
      userForm.value.start &&
      userForm.value.end &&
      this.tags.length === zero
    ) {
      this.validationError = false;

      const startDt = new Date(userForm.value.start);
      const normalStartDt = this.resetTime(startDt);
      const endDt = new Date(userForm.value.end);

      this.ValidateDate(normalStartDt, startDt, endDt);
    } else {
      this.maxDateError = false;
      this.futureDateError = false;
      this.validationError = true;
    }
  }

  ValidateDate(normalStartDt: Date, startDt: Date, endDt: Date) {
    if (normalStartDt >= this.maxDate && endDt <= this.today) {
      this.maxDateError = false;
      if (startDt <= endDt && startDt <= this.today && endDt <= this.today) {
        this.getEntity();
      } else {
        this.futureDateError = true;
      }
    } else {
      this.futureDateError = false;
      this.maxDateError = true;
    }
  }

  async getAgentsan() {
    const ssosessionStorage = environment.sso_sessionStorage;
    const sessionData = sessionStorage.getItem(ssosessionStorage);

    if (sessionData) {
      const user = JSON.parse(sessionData);
      const profile = user.profile.authz;

      if (profile) {
        const parsedProfile = JSON.parse(profile);
        const accessId = parsedProfile[0].accessId;
        this.agentSan = accessId.split(',')[0].split(':')[1];
      }
    }
  }

  getEntity() {
    this.validationError = false;

    const entity: Controls = {
      producerId: this.agentSan,
      applicationIDs: this.tags,
      startDate: this.startDate,
      endDate: this.endDate,
    };

    this.sharedService.setData(entity);
    this.router.navigate(['/result']);
  }
}